<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <div class="goBack" @click="goBack">
        <i class="goback-icon-cla"></i>
        <span>{{ $t('developer.goback') }}</span>
      </div>
    </div>

    <zkThreeRow>
      <div slot="search">
        <div class="user-row-cla">
          <span>{{ employeeInfo.formattedName }}</span>
          <el-tooltip
            v-if="employeeInfo.devicePermission === 14"
            class="item"
            effect="dark"
            content="管理员"
            placement="top-start"
          >
            <i
              style="font-size:20px;top:9px;margin-left:10px"
              class="user_icon zk-icon-yuangongguanli"
            ></i>
          </el-tooltip>

          <el-tooltip
            v-if="employeeInfo.devicePermission === 0"
            class="item"
            effect="dark"
            content="普通用户"
            placement="top-start"
          >
            <i
              style="font-size:20px;top:9px;margin-left:10px"
              class="user_icon zk-icon-yonghu"
            ></i>
          </el-tooltip>
        </div>
        <div class="user-row-cla">
          <div class="user-row-cla">
            <i style="font-size:20px" class="user_icon zk-icon-face"></i>
            <label style="margin-left:10px"
              >{{ $t('attendanceRecord.pin') }}:</label
            ><span style="margin-left:10px">{{ employeeInfo.employeeNo }}</span>
          </div>
          <div>
            <el-badge
              :value="
                employeeInfo.FingerCount > 0 ? employeeInfo.FingerCount : ''
              "
              class="item"
            >
              <i
                :class="{
                  'active-cla': employeeInfo.FingerCount > 0,
                  'bio-icon-cla': true,
                  'zk-icon-ic_zw-': true
                }"
                class=""
              ></i>
            </el-badge>
            <el-badge
              :value="
                employeeInfo.VisibleLightFaceCount > 0
                  ? employeeInfo.VisibleLightFaceCount
                  : ''
              "
              class="item"
            >
              <i
                :class="{
                  'active-cla': employeeInfo.VisibleLightFaceCount > 0,
                  'bio-icon-cla': true,
                  'zk-icon-ic_rl': true
                }"
              ></i>
            </el-badge>

            <el-badge
              :value="employeeInfo.FaceCount > 0 ? employeeInfo.FaceCount : ''"
              class="item"
            >
              <i
                :class="{
                  'active-cla': employeeInfo.FaceCount > 0,
                  'bio-icon-cla': true,
                  'zk-icon-nirFace': true
                }"
              ></i>
            </el-badge>

            <el-badge
              :value="
                employeeInfo.PalmPrintCount > 0
                  ? employeeInfo.PalmPrintCount
                  : ''
              "
              class="item"
            >
              <i
                :class="{
                  'active-cla': employeeInfo.PalmPrintCount > 0,
                  'bio-icon-cla': true,
                  'zk-icon-ic_zw': true
                }"
              ></i>
            </el-badge>
          </div>
        </div>
        <div v-if="employeeInfo.cardNo" class="user-row-cla">
          <i class="user_icon zk-icon-card"></i>
          <label style="margin-left:10px">{{ $t('employee.badgeNo') }}:</label
          ><span style="margin-left:10px">{{ employeeInfo.cardNo }}</span>
        </div>
      </div>

      <div slot="table">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('company.assEquipment')" name="first">
            <deviceList
              :employeeId="employeeId"
              v-if="activeName === 'first'"
            ></deviceList>
          </el-tab-pane>
          <el-tab-pane :label="$t('company.accAuthority')" name="second">
            <accAuth
              :employeeId="employeeId"
              v-if="activeName === 'second'"
            ></accAuth>
          </el-tab-pane>
        </el-tabs>
      </div>
    </zkThreeRow>
  </div>
</template>

<script>
import accAuth from './employeeDetail/accAuth.vue'
import deviceList from './employeeDetail/deviceList.vue'
import * as employeeApi from '@/services/employeeApi.js'
export default {
  data() {
    return {
      activeName: 'first',
      employeeId: '',
      companyId: '',
      employeeInfo: {
        BioDataCount: 0,
        FaceCount: 0,
        FingerCount: 0,
        PalmPrintCount: 0,
        VisibleLightFaceCount: 0,
        cardNo: '',
        employeeNo: '',
        formattedName: '',
        devicePermission: ''
      }
    }
  },
  components: {
    deviceList,
    accAuth
  },
  mounted() {
    this.employeeId = this.$route.query.employeeId
    this.companyId = this.$route.query.companyId
    this.getEmployeeInfo()
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/tenantManager/companyDetails'
      })
    },
    getEmployeeInfo() {
      let params = {
        employeeId: this.employeeId,
        companyId: this.companyId
      }
      employeeApi
        .findEmployeeEnrollment(params)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.results
            this.employeeInfo.BioDataCount = result.BioDataCount
            this.employeeInfo.FaceCount = result.FaceCount
            this.employeeInfo.FingerCount = result.FingerCount
            this.employeeInfo.PalmPrintCount = result.PalmPrintCount
            this.employeeInfo.VisibleLightFaceCount =
              result.VisibleLightFaceCount
            this.employeeInfo.cardNo = result.cardNo
            this.employeeInfo.employeeNo = result.employeeNo
            this.employeeInfo.formattedName = result.formattedName
            this.employeeInfo.devicePermission = result.devicePermission
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    }
  }
}
</script>
<style scoped lang="less">
.user_icon {
  font-size: 25px;
  color: #4db22f;
  position: relative;
  top: 5px;
  cursor: pointer;
}
.user-row-cla {
  height: 40px;
  line-height: 40px;
  display: flex;
}
.bio-icon-cla {
  margin-left: 30px;
  font-size: 25px;
}
.active-cla {
  color: #4db22f;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/employeeDetail.vue